import { NavLink, useLocation } from "react-router-dom";

import BreakPoints from "../BreakPoints";

import QuestionSearch from "./QuestionManagement/QuestionsSearch";
import AskState from "./questionPage/helper/AskState";

export default function NavLinks({ position }) {
  const location = useLocation();
  const { xSmall, small, medium, large, xLarge, xXLarge } = BreakPoints();

  return (
    <nav className="navlinks gap-10 d-flex">
      <NavLink to="/">{position === "header" ? "Home" : <i className="fa-solid fa-house icon"></i>}</NavLink>
      <NavLink to="/query">{position === "header" ? "Questions" : <i className="fa-solid fa-comments"></i>} </NavLink>
      {location.pathname === "/query" && <QuestionSearch position={position} />}

      {position === "footer" && <AskState />}
      <NavLink style={{ opacity: "0.5" }} className={"opacity-5 event-none"}>
        {position === "header" ? "Article" : <i className="fa-solid fa-newspaper"></i>}
      </NavLink>
      <NavLink to={"/posts"}>{position === "header" ? "posts" : <i className="fa-solid fa-message"></i>}</NavLink>
    </nav>
  );
}
